<!-- UI-5 (5f): ZayaAI status dot + label for a task-run state (design .status-dot).
     Single source of truth for the state→colour mapping, reused by the recent-runs
     table now and the deferred toolbar pipeline flyout later. -->
<template>
  <span class="trs-dot-wrap" :title="state">
    <span class="status-dot" :class="meta.cls"></span>
    <span class="trs-label">{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'TaskRunStatusDot',
  props: {
    state: {type: String, default: null}
  },
  computed: {
    meta() {
      switch (this.state) {
        case 'FINISHED':
          return {cls: 'ok', key: 'finished'};
        case 'RUNNING':
          return {cls: 'run', key: 'running'};
        case 'QUEUING':
        case 'QUEUED':
        case 'PENDING':
        case 'PROVISIONED':
          return {cls: 'warn', key: 'pending'};
        case 'CREATED':
          return {cls: 'idle', key: 'created'};
        case 'FAILED':
          return {cls: 'err', key: 'failed'};
        default:
          return {cls: 'idle', key: null};
      }
    },
    label() {
      return this.meta.key ? this.$t('app-engine.task-run.state.' + this.meta.key) : (this.state || '');
    }
  }
};
</script>

<style scoped>
.trs-dot-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: #0e1116;
  white-space: nowrap;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 8px;
}

.status-dot.ok { background: #1e9c6b; }
.status-dot.run { background: #1e63d0; }
.status-dot.warn { background: #c98a19; }
.status-dot.idle { background: #8a91a1; }
.status-dot.err { background: #c8443c; }

.trs-label {
  font-weight: 500;
}
</style>
